import Device from '../helpers/Device';

export default class HeaderMenu {
  constructor() {
    this.$header = $('.top-header .header-nav');
    this.isFixed = 0;

    this._addEvent();
  }

  /**
   * イベント登録.
   * @private
   */
  _addEvent() {
    $(window).scroll(() => {
      let scrollTop = $(window).scrollTop();

      if (scrollTop > 0) {
        if (!this.isFixed) {
          this._enableFix();
        }
      } else {
        this._disableFix();
      }
    });
  }

  /**
   * ヘッダーのFIXを適用.
   * @private
   */
  _enableFix() {
    this.$header.addClass('is-fix');
    this.isFixed = true;
  }

  /**
   * ヘッダーのFIXを解除.
   * @private
   */
  _disableFix() {
    this.$header.removeClass('is-fix');
    this.isFixed = false;
  }
}
